<script>
import { mapGetters } from 'vuex';
import ContributorPage from '../pages/ContributorPage';
import ContactPage from '../pages/ContactPage';
import InfoPage from '../pages/InfoPage';

export default {
    name: 'OverlayPage',
    components: {
        ContributorPage,
        ContactPage,
        InfoPage,
    },
    data() {
        return {
            isVisible: false,
        }
    },
    mounted() {
        document.addEventListener('keyup', () => { if (event.keyCode === 27) this.onClose(); });
        this.isVisible = true;
    },
    methods: {
        onClose() {
            if (this.showBack)
                this.$store.dispatch('previousOverlayPage');
            else 
                this.$store.dispatch('closeOverlay');
        },
    },
    computed: {
        ...mapGetters({
            isLoading: 'getContributorsIsLoading',
            page: 'overlayGetCurrentPage',
            showBack: 'overlayHasPreviousPage',
            navDirection: 'overlayGetNavDirection',
        }),
        pageSlideTransitionName() {
            return this.navDirection === 'back' ? 'slide-right' : 'slide-left';
        }
    },
    watch: {
        'page' () {
            this.$scrollTo('#overlayPage', 50, { container: this.$refs.scroller, easing: [0.165, 0.84, 0.44, 1] })
            // console.log(this.$refs.scroller.scrollTop)
            // this.$refs.scroller.scrollTop = 0;
        }
    }
};
</script>

<template>
    <section class="overlay" >
        <transition name="scale">
            <div class="overlay__background" v-if="isVisible"></div>
        </transition>
        <transition name="border">
            <div class="overlay__border" v-if="isVisible"></div>
        </transition>
        <transition name="fade">
            <div class="overlay__content" v-if="isVisible">
                <button class="overlay__close-button" v-on:click="onClose"></button>
                <div class="overlay__pages" v-bar="{ preventParentScroll: true }">
                    <div ref="scroller">
                        <transition v-bind:name="pageSlideTransitionName" mode="out-in">
                            <component 
                                id="overlayPage"
                                v-if="page"
                                v-bind:key="page.component + page.slug" 
                                v-bind:is="page.component"
                                v-bind="page.props">
                            </component>
                        </transition>
                    </div>
                </div>
            </div>
        </transition>
    </section>
</template>

<style lang="scss">
.overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    z-index: 100;

    a {
        border-color: rgba($color-light, .4);
        color: $color-light;
    }
}
.overlay__background {
    position: absolute;
    top: 50vh; right: 50vw;
    width: 100vw;
    height: 100vh;
    margin: -50vh -50vw;
    background: rgba($color-primary, .97);
    z-index: -1;
}
.overlay__border {
    position: absolute;
    top: 50vh; right: 50vw;
    width: 100vw;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    margin: -50vh -50vw;
    box-sizing: border-box;
    border: 4rem $color-light solid;
    z-index: -1;

    @include breakpoint('sm-down') {
        border-width: 1.6rem;
    }
}
.overlay__content {
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
    margin: 4rem;
    overflow: hidden;

    @include breakpoint('sm-down') {
        margin: 1.6rem;
    }
}
.overlay__pages {
    width: 100%;
    height: 100%;
}
.overlay__close-button {
    position: absolute;
    top: 4.6rem; right: 3.7rem;
    width: 4.8rem; height: 4.8rem;
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    background: center url('~@/assets/images/ico-close-overlay.svg') no-repeat transparent;
    cursor: pointer;
    z-index: 1;

    @include breakpoint('sm-down') {
        top: 1.92rem; right: 1.92rem;
        width: 2.08rem; height: 2.08rem;
        background-size: 2.08rem;
    }
}

.scale-enter-active, .scale-leave-active {
    transition: 
        transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
        opacity 400ms linear;
}
.scale-enter, .scale-leave-to {
    transform: scale(0);
    opacity: 0;
}

.border-enter-active, .border-leave-active {
    transition: 
        border 600ms 0ms cubic-bezier(0.165, 0.84, 0.44, 1),
        opacity 150ms linear;
}
.border-enter, .border-leave-to {
    border-width: 0;
    opacity: 0;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 300ms 400ms linear;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}

.slide-right-enter-active, .slide-right-leave-active {
  transition: opacity 200ms linear, transform 350ms;
}
.slide-right-enter {
  opacity: 0;
  transform: translateX(-10%);
}
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(10%);
}

.slide-left-enter-active, .slide-left-leave-active {
  transition: opacity 200ms linear, transform 350ms;
}
.slide-left-enter {
  opacity: 0;
  transform: translateX(10%);
}
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-10%);
}
</style>
